import { Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { CourseLevelService } from "../../services/CourseLevelService";
import { MULTI, Selector } from "./Selector";

export const CourseLevelSelect = ({
  selectHandler,
  clear,
  size,
  selectedLevels,
  id,
  required,
}) => {
  const { t } = useTranslation();
  const [courseLevels, setCourseLevels] = useState([]);

  useEffect(() => {
    CourseLevelService.getCourseLevels().then((levels) => {
      setCourseLevels(
        levels.map((level) => ({
          id: level.id,
          label: `${t("courseCodePattern.level")} ${level.courseLevel} (${level.range.start} - ${level.range.end})`,
        }))
      );
    });
  }, []);

  return (
    <Selector
      type={MULTI}
      id={id ?? "course-level-select"}
      label={
        <Text size={size ? size : "small"}>
          {t("filter.courseLevels") + (required ? "*" : "")}
        </Text>
      }
      options={courseLevels}
      selectHandler={selectHandler}
      selectedOptions={selectedLevels}
      clear={clear}
      size={size}
    />
  );
};
